import APIConfiguration from '@savgroup-front-common/configuration/api';
import { COMMON_QUERY_PARAMS } from '@savgroup-front-common/constants/shared';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared/supportedMethods';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.payment}invoices/${COMMON_QUERY_PARAMS.INVOICE_ID}/paymentIntent`;

interface CreatePaymentIntentCommandPayload {
  invoiceId: string;
}

async function createPaymentIntent({
  invoiceId,
}: CreatePaymentIntentCommandPayload): Promise<
  BackResponse<string> | BackResponseFailure
> {
  const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.INVOICE_ID, invoiceId);

  try {
    const response = await apiCall<BackResponse<string>>(url, {
      method: SUPPORTED_METHODS.POST,
      json: {
        redirectLocalhost: window?.location.hostname === 'localhost',
      },
    });

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default createPaymentIntent;
